import { MEASURE_SCORE_BY_SKILL_NAME } from '../../constants/assessments';

export const getMeasureScoreBySkillName = (skillName, measure) => {
    const measureScore = MEASURE_SCORE_BY_SKILL_NAME[skillName];
    if (Array.isArray(measureScore) && measureScore.includes(measure)) {
        return measure;
    }
    return measureScore;
};
